import { useState } from "react";
import axios from "axios";
import "./RequestQuote.css";

export default function RequestQuote() {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    company: "",
    country: "India",
    productType: "",
    quantity: "",
    message: ""
  });

  const handleChange = e =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const submitRFQ = async e => {
    e.preventDefault();

    try {
      await axios.post("http://localhost:5000/api/rfqs", form);
      alert("✅ Quote request submitted");
      setForm({});
    } catch (err) {
      alert("❌ Failed to submit RFQ");
    }
  };

  return (
    <section className="rfq-section">
      <div className="container">
        <div className="rfq-header">
          <h1>Request a Quote</h1>
          <p>Get customized pricing from NX Optics</p>
        </div>

        <form className="rfq-form" onSubmit={submitRFQ}>
          <input name="firstName" placeholder="First Name *" onChange={handleChange} />
          <input name="lastName" placeholder="Last Name *" onChange={handleChange} />
          <input name="email" placeholder="Email *" onChange={handleChange} />
          <input name="phone" placeholder="Phone *" onChange={handleChange} />
          <input name="company" placeholder="Company" onChange={handleChange} />
          <input name="productType" placeholder="Product Type" onChange={handleChange} />
          <input name="quantity" type="number" placeholder="Quantity" onChange={handleChange} />
          <textarea name="message" placeholder="Project details" onChange={handleChange} />
          <button className="rfq-btn">Submit Quote Request</button>
        </form>
      </div>
    </section>
  );
}
